import React from 'react';
import EarningsSidebarLayout from '../earnings-sidebar-layout';
import {Route, Switch} from 'react-router-dom';
import {useChecklist} from '../../hooks/useChecklist';
import HomePage from '../home-page';
import {EducationPhase} from '../../types/enums';
import TermsBannerMessage from '../../../portfolio/components/terms-banner-message/terms-banner-message';
import StudentNotificationBanner from '../StudentNotificationBanner';
import NextStepsBanners from '../../../portfolio/components/next-steps-modal/banners';
import TransferDeadlineEducationModal from '../../../portfolio/components/transfer-education-deadline-modal/transfer-education-deadline-modal';
import CollegesNotOfferingTransferTermModal from '../../../portfolio/components/colleges-not-offering-transfer-term-modal/colleges-not-offering-transfer-term-modal';
import usePlatformContext from '../../hooks/usePlatform';
import TransferSidebar from '../../../transfer-student/portfolio-sidebar/components/portfolio-sidebar';
import RoutedPortfolio from 'portfolio/components/routed-portfolio/routed-portfolio';
import ChecklistPage from 'src/components/checklist/checklist-page';

interface EarningsSidebarPagesProps {
  educationPhase: EducationPhase;
}

const EarningsSidebarPages = ({educationPhase}: EarningsSidebarPagesProps) => {
  const platformContext = usePlatformContext();
  const transfer = educationPhase === EducationPhase.COMMUNITY_COLLEGE;
  const checklistData = useChecklist(educationPhase);

  return (
    <EarningsSidebarLayout
      headerComponents={
        <Switch>
          <Route
            path="/portfolio"
            render={() => (
              <>
                {transfer && <TermsBannerMessage />}
                {platformContext.isBasic && <StudentNotificationBanner transfer={transfer} />}
                {!transfer && <NextStepsBanners />}
                {transfer && <TransferDeadlineEducationModal />}
                {transfer && <CollegesNotOfferingTransferTermModal />}
              </>
            )}
          />
        </Switch>
      }
      sidebar={transfer ? <TransferSidebar /> : undefined}
    >
      <Switch>
        <Route path="/portfolio" component={RoutedPortfolio} />
        <Route
          path="/home"
          render={() => <HomePage checklistData={checklistData} educationPhase={educationPhase} />}
        />
        <Route path="/checklist" render={() => <ChecklistPage checklistData={checklistData} />} />
      </Switch>
    </EarningsSidebarLayout>
  );
};

export default EarningsSidebarPages;
